<div formGroupName="reqBusinessArea">
  <mat-card class="cur-card">
    <mat-card-header>
      <mat-card-title>入金報告表出力対象</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-form-field appearance="fill"
          class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
          <mat-label>会社</mat-label>
          <mat-select formControlName="companycode" class="disabled-select-color">
            <mat-option *ngFor="let type of codeMap?.get('S900021')"
              [value]="type.userCode">{{type.hyojiCont}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill"
          class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
          <mat-label>入金地区</mat-label>
          <mat-select formControlName="rcvmnyTantoAreacode" class="disabled-select-color">
            <mat-option *ngFor="let type of codeMap?.get('S300561')"
              [value]="type.userCode">{{type.hyojiCont}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-form-field appearance="outline"
          class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
          <mat-label class="mat-label-important">報告年月日</mat-label>
          <input matInput [matDatepicker]="incYmFrom" autocomplete="off" formControlName="reportYearmonthdate"
            class="font-color-display-only" maxlength="10">
          <mat-datepicker-toggle matSuffix [for]="incYmFrom"></mat-datepicker-toggle>
          <mat-datepicker #incYmFrom></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
        <mat-card-actions class="btn_area_right">
          <button type="submit" [disabled]="outputConditionForm.invalid" mat-raised-button color="primary"
            class="btn">出力</button>
        </mat-card-actions>
      </div>
    </mat-card-content>
  </mat-card>
</div>